import Vue from 'vue'
import Vuex from 'vuex'

import sessionStore from '@/stores/session'
import _ from 'underscore'

const groupStore = {
  namespaced: true,
  state: {
    actualGroupLevel : 1,
  },
  mutations: {
    SET_ACTUAL_GROUP_LEVEL(state, groupLevel) {
      state.actualGroupLevel = groupLevel
    },



  },
  actions: {

    // Setting of actual group level
    setActualGroupLevel ({commit, state},data) {
      commit('SET_ACTUAL_GROUP_LEVEL',data)
    },

    //Ajout d'un groupe au profile usager (Groupe Niveau 1)
    addGroupToProfile({commit, state},device){
      return Vue.axios.get(`/rest/profile/${sessionStore.state.profileId}/addrecordeddevice?deviceId=${device.deviceId}&deviceKey=${device.deviceKey}`)
      .then((response) => {
        console.log(response.data)
        return Promise.resolve(response)
      })
      
    },


    // EXEMPLE DE POST se trouvant dans session store
    refreshProfileData ({commit, state}) {
      console.log('store_session_refresh_profile_data');

      let payload = { "firstName": 'John', "email":'Bidon', "lastName": 'Doe'}
      Vue.axios.post(`/rest/profile/${localStorage.actualUserName}/login`, payload)
      .then( (response) => {
        console.log("store_session_refressed");
        console.log(response.data.userData)
        commit('SET_PROFILE_DATA',response.data.userData)
      })
      .catch( (e) => {
        console.log(e)
      })

    },

    // Création d'un nouveau groupe dans le profil
    createNewGroupInProfile ({commit, state},groupInfo) {
      let payload = groupInfo
      Vue.axios.post(`/rest/profile/${groupInfo.profileId}/createNewGroupInProfile`, payload)
      .then( (response) => {
        console.log(response.data);
      })
      .catch( (e) => {
        console.log(e)
      })

    },

    // Création d'un nouveau sous groupe dans le groupe
    createNewGroupInGroup ({commit, state},groupInfo) {
      let payload = groupInfo
      Vue.axios.post(`/rest/profile/${groupInfo.profileId}/createNewGroupInGroup`, payload)
      .then( (response) => {
        console.log(response.data);
      })
      .catch( (e) => {
        console.log(e)
      })

    },





  }
}

export default groupStore


// WEBPACK FOOTER //
// ./src/stores/group.js